import { useFetch } from "../useFetch";
import type {
	PortfolioResponse,
	CreatePortfolioPayload,
	UpdatePortfolioPayload,
} from "../../core/types/services";

// ============================================
// GET PORTFOLIO ITEM BY ID
// ============================================
export function usePortfolioItem(id: number) {
	return useFetch<PortfolioResponse>({
		endpoint: `/portafolio/${id}`, // Asumiendo endpoint en español
		method: "GET",
	});
}

// ============================================
// GET PORTFOLIO BY PROVIDER
// ============================================
export function usePortfolioByProvider(providerId: number) {
	return useFetch<PortfolioResponse[]>({
		endpoint: `/portafolio/provider/${providerId}`,
		method: "GET",
	});
}

// ============================================
// CREATE PORTFOLIO ITEM
// ============================================
export function useCreatePortfolio() {
	const fetch = useFetch<PortfolioResponse, CreatePortfolioPayload>({
		endpoint: "/portafolio",
		method: "POST",
		auto: false,
	});

	const create = (
		data: CreatePortfolioPayload,
		// El nombre de la propiedad aquí debe coincidir con el del DTO/Backend
		files?: { pictures_portafolio?: File[] },
	) => {
		return fetch.execute({ body: data, files });
	};

	return { ...fetch, create };
}

// ============================================
// UPDATE PORTFOLIO ITEM
// ============================================
export function useUpdatePortfolio(id: number) {
	const fetch = useFetch<PortfolioResponse, UpdatePortfolioPayload>({
		endpoint: `/portafolio/${id}`,
		method: "PATCH",
		auto: false,
	});

	const update = (
		data: UpdatePortfolioPayload,
		files?: { pictures_portafolio?: File[] },
	) => {
		return fetch.execute({ body: data, files });
	};

	return { ...fetch, update };
}

// ============================================
// DELETE PORTFOLIO ITEM
// ============================================
export function useDeletePortfolio() {
	const fetch = useFetch<{ message: string }>({
		endpoint: "/portafolio",
		method: "DELETE",
		auto: false,
	});

	const remove = (id: number) => {
		return fetch.execute({ endpoint: `/portafolio/${id}` });
	};

	return { ...fetch, remove };
}
